import { initFavoritesForSearchResults, initClearAllFavorites } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Favorites';
import { initComparedForSearchResults, updateCompareView } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Compare';
import CompareList from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/CompareList';
import { facilityCard } from '@PROJECT_ROOT/assets/desktop/js/search/FacilityCard';
import favoriteFilterForm from '@PROJECT_ROOT/assets/desktop/js/search/favoriteFilter';

$(() => {
    initializeFacilityCards();

    favoriteFilterForm({
        form: '#favoriteForm',
        from: '#favoriteForm_from',
        to: '#favoriteForm_to',
        persons: '#favoriteForm_persons',
        sort: '#favoriteForm_sort',
        loader: '#favoriteListLoader',
    })();

    CompareList.init({
        onRemove(unitId, numberOfCompared) { updateCompareView({ unitId, numberOfCompared, removed: true })(); },
    });

    initClearAllFavorites();
    initFavoritesForSearchResults({
        onAdd() { window.location.reload(); },
        onRemove() { window.location.reload(); },
    });

    initComparedForSearchResults({
        onAdd() { CompareList.update({ removed: false }); },
        onRemove() { CompareList.update({ remove: true }); },
    });
});

function initializeFacilityCards() {
    document.querySelectorAll('#searchResults > li[data-facility-id]').forEach((facility) => {
        facilityCard({ facility })();
    });
}
